import type { AxiosResponse } from "axios";
import type { FieldValues } from "react-hook-form";

// import normalizeTypes from "../components/form-viewer/utils/normalizeTypes"
import api from "../utils/AxiosInterceptor";

export async function processStartRequest(
  inputs: FieldValues,
  processDefinitionId: string
): Promise<AxiosResponse> {
  return api.post(`/api/v1/solicitacoes/process/${processDefinitionId}/start`, {
    variables: inputs,
  });
}

export async function getProcessTasks(
  processId: string
): Promise<AxiosResponse> {
  return api.get(`/api/v1/solicitacoes/${processId}/tasks`);
}

export async function getRequestSteps(
  requestId: string
): Promise<AxiosResponse> {
  return api.get(`/api/v1/solicitacoes/${requestId}/etapas`);
}
